"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateContacts = void 0;
const generate_contact_1 = require("./generate-contact");
const generateContacts = (length = 100, options) => Array.from({ length }, (_, i) => (0, generate_contact_1.generateContact)(i, options));
exports.generateContacts = generateContacts;
